import React, {Component} from "react";
import autosize from "autosize";
import {Col} from "reactstrap";
import PropTypes from "prop-types";
import {Strings} from "./Strings";

export class DescriptionBox extends Component {
    constructor(props) {
        super(props);

        let date = new Date();
        let day = date.getDate();
        if (day < 10) {
            day = "0" + day;
        }
        let month = date.getMonth() + 1;
        if (month < 10) {
            month = "0" + month;
        }
        let year = date.getFullYear();
        this.dateString = day + "-" + month + "-" + year;

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.textarea.focus();
        autosize(this.textarea);
    }


    handleChange(e) {
        let newInputData = this.props.inputData;
        newInputData.description = e.target.value;
        this.props.onChange(newInputData);
    }


    render() {
        return <Col className="headerless">
            <div className="block">
                <h2>{Strings.titleProjectDescription}</h2>
                <textarea className="form-control" onChange={this.handleChange} maxLength="512"
                          value={this.props.inputData.description} rows={1} ref={c => (this.textarea = c)}/>
                Date: {this.dateString}
            </div>
        </Col>;
    }
}

DescriptionBox.propTypes = {
    onChange: PropTypes.func,
    inputData: PropTypes.shape({
        description: PropTypes.string
    })
};